import * as ReactRouter from 'react-router';
import * as _ from 'lodash';

export type AppRoute =
    | {
          type: 'InvalidRoute';
      }
    | {
          type: 'Overview';
      }
    | {
          type: 'OverviewOrganization';
      }
    | {
          type: 'OverviewLocation';
          locationId: string;
      }
    | {
          type: 'OverviewLocationDevices';
          locationId: string;
      }
    | {
          type: 'OverviewSite';
          locationId: string;
          siteId: string;
      }
    | {
          type: 'OverviewSiteDeviceDetails';
          locationId: string;
          siteId: string;
          deviceId: string;
      }
    | {
          type: 'OverviewSiteReadings';
          locationId: string;
          siteId: string;
      }
    | {
          type: 'OverviewSiteTrends';
          locationId: string;
          siteId: string;
      }
    | {
          type: 'OverviewSiteDevices';
          locationId: string;
          siteId: string;
      }
    | {
          type: 'OverviewSiteDevicesDeviceDetails';
          locationId: string;
          siteId: string;
          deviceId: string;
      }
    | { type: 'OverviewSiteTimeline'; locationId: string; siteId: string }
    | { type: 'OverviewSiteEventDetails'; locationId: string; siteId: string; alarmId: string; deviceId: string }
    | {
          type: 'OverviewSiteTimelineEventDetails';
          locationId: string;
          siteId: string;
          alarmId: string;
          deviceId: string;
      }
    | {
          type: 'Devices';
      }
    | {
          type: 'DevicesOrganization';
      }
    | {
          type: 'DevicesOrganizationDeviceDetails';
          deviceId: string;
      }
    | {
          type: 'DevicesLocation';
          locationId: string;
      }
    | {
          type: 'DevicesLocationDeviceDetails';
          locationId: string;
          deviceId: string;
      }
    | {
          type: 'Timeline';
      }
    | {
          type: 'TimelineOrganization';
      }
    | {
          type: 'TimelineOrganizationEventDetails';
          alarmId: string;
          deviceId: string;
      }
    | {
          type: 'TimelineLocation';
          locationId: string;
      }
    | {
          type: 'TimelineLocationEventDetails';
          locationId: string;
          alarmId: string;
          deviceId: string;
      }
    | {
          type: 'TimelineOrganizationTabDetails';
          eventId: string;
          deviceId: string;
          tabId: string;
          phaseDate: number;
      }
    | {
          type: 'TimelineSiteTabDetails';
          locationId: string;
          siteId: string;
          eventId: string;
          deviceId: string;
          tabId: string;
          phaseDate: number;
      }
    | {
          type: 'TimelineLocationTabDetails';
          locationId: string;
          eventId: string;
          deviceId: string;
          tabId: string;
          phaseDate: number;
      }
    | { type: 'Settings' }
    | { type: 'MyProfile' }
    | { type: 'ManageUser'; orgId: string }
    | { type: 'AddUser'; orgId: string }
    | { type: 'User'; userId: string; orgId: string }
    | { type: 'ManageLocation'; orgId: string }
    | { type: 'AddLocation'; orgId: string }
    | { type: 'LocationProfile'; locationId: string; orgId: string }
    | { type: 'EditLocation'; orgId: string; locationId: string }
    | { type: 'AddSite'; orgId: string; locationId: string }
    | { type: 'SiteProfile'; orgId: string; locationId: string; siteId: string }
    | { type: 'EditSite'; orgId: string; locationId: string; siteId: string }
    | { type: 'AddDevice'; orgId: string; locationId: string; siteId: string }
    | { type: 'DeviceProfile'; orgId: string; locationId: string; siteId: string; deviceId: string }
    | { type: 'PxDeviceProfile'; orgId: string; locationId: string; siteId: string; deviceId: string }
    | { type: 'MeshDeviceProfile'; orgId: string; locationId: string; siteId: string; deviceId: string }
    | { type: 'EditConnectedDevice'; orgId: string; locationId: string; siteId: string; deviceId: string }
    | {
          type: 'AcquireSubscription';
          orgId: string;
          locationId: string;
          siteId: string;
          deviceId: string;
          subType: string;
      }
    | { type: 'PxDeviceProfile'; orgId: string; locationId: string; siteId: string; deviceId: string }
    | { type: 'StarfishDeviceProfile'; orgId: string; locationId: string; siteId: string; deviceId: string }
    | { type: 'EditStarfishConnectedDevice'; orgId: string; locationId: string; siteId: string; deviceId: string }
    | {
          type: 'EditStarfishChildDevice';
          orgId: string;
          locationId: string;
          siteId: string;
          deviceId: string;
          childDeviceId: string;
      }
    | { type: 'AddChildDevice'; orgId: string; locationId: string; siteId: string; deviceId: string }
    | { type: 'AddStarFishChildDevice'; orgId: string; locationId: string; siteId: string; deviceId: string }
    | {
          type: 'ChildDeviceProfile';
          orgId: string;
          locationId: string;
          siteId: string;
          deviceId: string;
          childDeviceId: string;
      }
    | {
          type: 'PxChildDeviceProfile';
          orgId: string;
          locationId: string;
          siteId: string;
          deviceId: string;
          childDeviceId: string;
      }
    | {
          type: 'StarfishChildDeviceProfile';
          orgId: string;
          locationId: string;
          siteId: string;
          deviceId: string;
          childDeviceId: string;
      }
    | { type: 'ManageAlarms'; orgId: string }
    | { type: 'ManageDeviceProfiles'; orgId: string }
    | { type: 'AddManageDeviceProfile'; orgId: string }
    | {
          type: 'EditDeviceProfile';
          orgId: string;
          locationId: string;
          siteId: string;
          deviceId: string;
          childDeviceId: string;
      }
    | { type: 'Legal' }
    | { type: 'EULA' }
    | { type: 'TermsAndConditions' }
    | { type: 'OpenSource' }
    | {
          type: 'OpenSourceContent';
          name: string;
      }
    | { type: 'ForgotPassword' }
    | { type: 'Root' }
    | { type: 'Login' };

export const AppRoutes: { [k in AppRoute['type']]: string } = {
    Overview: '/overview',
    OverviewOrganization: '/overview',

    OverviewLocation: '/overview/locations/:locationId',
    OverviewLocationDevices: '/overview/locations/:locationId/devices',

    OverviewSite: '/overview/locations/:locationId/sites/:siteId',
    OverviewSiteReadings: '/overview/locations/:locationId/sites/:siteId/readings',
    OverviewSiteTrends: '/overview/locations/:locationId/sites/:siteId/trends',
    OverviewSiteDevices: '/overview/locations/:locationId/sites/:siteId/all-devices',
    OverviewSiteDeviceDetails: '/overview/locations/:locationId/sites/:siteId/devices/:deviceId',
    OverviewSiteDevicesDeviceDetails: '/overview/locations/:locationId/sites/:siteId/all-devices/:deviceId',

    OverviewSiteTimeline: '/overview/locations/:locationId/sites/:siteId/timeline',
    OverviewSiteEventDetails: '/overview/locations/:locationId/sites/:siteId/events/:alarmId/devices/:deviceId',
    OverviewSiteTimelineEventDetails:
        '/overview/locations/:locationId/sites/:siteId/timeline/events/:alarmId/devices/:deviceId',

    Devices: '/devices',
    DevicesOrganization: '/devices',
    DevicesOrganizationDeviceDetails: '/devices/:deviceId',
    DevicesLocation: '/devices/locations/:locationId',
    DevicesLocationDeviceDetails: '/devices/locations/:locationId/devices/:deviceId',
    Timeline: '/timelines',
    TimelineOrganization: '/timelines',
    TimelineOrganizationEventDetails: '/timelines/events/:alarmId/devices/:deviceId',
    TimelineLocation: '/timelines/locations/:locationId',
    TimelineLocationEventDetails: '/timelines/locations/:locationId/events/:alarmId/devices/:deviceId',

    TimelineOrganizationTabDetails: '/timelines/events/:eventId/devices/:deviceId/tabView/:tabId/PhaseDate/:phaseDate',
    TimelineSiteTabDetails:
        '/overview/locations/:locationId/sites/:siteId/event/:eventId/devices/:deviceId/tabView/:tabId/PhaseDate/:phaseDate',
    TimelineLocationTabDetails:
        '/timelines/locations/:locationId/events/:eventId/devices/:deviceId/tabView/:tabId/PhaseDate/:phaseDate',

    Settings: '/settings',
    MyProfile: '/settings/myProfile',
    ManageUser: '/manage-user/org/:orgId',
    AddUser: '/manage-user/org/:orgId/add-user',
    User: '/manage-user/org/:orgId/user/:userId',
    ManageLocation: '/manage-location/org/:orgId',
    ManageAlarms: '/manage-alarms/org/:orgId',
    ManageDeviceProfiles: '/manage-device-profiles/org/:orgId',
    AddLocation: '/manage-location/org/:orgId/add-location',
    LocationProfile: '/manage-location/org/:orgId/location/:locationId',
    EditLocation: '/manage-location/org/:orgId/location/:locationId/edit-location',
    AddSite: '/manage-location/org/:orgId/location/:locationId/add-site',
    SiteProfile: '/manage-location/org/:orgId/location/:locationId/site/:siteId',
    EditSite: '/manage-location/org/:orgId/location/:locationId/site/:siteId/edit-site',
    AddDevice: '/manage-location/org/:orgId/location/:locationId/sites/:siteId/add-device',
    DeviceProfile: '/manage-location/org/:orgId/location/:locationId/sites/:siteId/device/:deviceId',
    StarfishDeviceProfile: '/manage-location/org/:orgId/location/:locationId/sites/:siteId/blgdevice/:deviceId',
    PxDeviceProfile: '/manage-location/org/:orgId/location/:locationId/sites/:siteId/pxdevice/:deviceId',
    MeshDeviceProfile: '/manage-location/org/:orgId/location/:locationId/sites/:siteId/meshdevice/:deviceId',
    AcquireSubscription:
        '/manage-location/org/:orgId/location/:locationId/sites/:siteId/meshdevicesub/:deviceId/subType/:subType',
    EditConnectedDevice:
        '/manage-location/org/:orgId/location/:locationId/sites/:siteId/device/:deviceId/edit-connected-device',
    EditStarfishConnectedDevice:
        '/manage-location/org/:orgId/location/:locationId/sites/:siteId/blgdevice/:deviceId/edit-starconnected-device',
    EditStarfishChildDevice:
        '/manage-location/org/:orgId/location/:locationId/sites/:siteId/pxdevice/:deviceId/starfishchilddevice/:childDeviceId/edit-child',
    AddChildDevice: '/manage-location/org/:orgId/location/:locationId/sites/:siteId/device/:deviceId/add-child-device',
    AddStarFishChildDevice:
        '/manage-location/org/:orgId/location/:locationId/sites/:siteId/pxdevice/:deviceId/add-starchild-device',
    ChildDeviceProfile:
        '/manage-location/org/:orgId/location/:locationId/sites/:siteId/device/:deviceId/childdevice/:childDeviceId',
    StarfishChildDeviceProfile:
        '/manage-location/org/:orgId/location/:locationId/sites/:siteId/pxdevice/:deviceId/starfishchilddevice/:childDeviceId',
    AddManageDeviceProfile: '/manage-device-profiles/org/:orgId/add-device-profile',
    PxChildDeviceProfile:
        '/manage-location/org/:orgId/location/:locationId/sites/:siteId/pxdevice/:deviceId/pxchilddevice/:childDeviceId',
    EditDeviceProfile:
        '/manage-location/org/:orgId/location/:locationId/sites/:siteId/device/:deviceId/childdevice/:childDeviceId/edit-device',
    Legal: '/legal',
    EULA: '/legal/eula',
    TermsAndConditions: '/legal/terms',
    OpenSource: '/legal/open-source',
    OpenSourceContent: '/legal/open-source/:name',

    ForgotPassword: '/forgot-password',
    Login: '/login',

    Root: '/',

    InvalidRoute: '/invalid',
};

export const removeLocationId = (appRoute: AppRoute, orgId: string): AppRoute => {
    switch (appRoute.type) {
        case 'Overview':
        case 'OverviewOrganization':
        case 'OverviewLocation':
            return { type: 'Overview' };
        case 'Timeline':
        case 'TimelineOrganization':
        case 'TimelineLocation':
            return { type: 'Timeline' };
        case 'Devices':
        case 'DevicesOrganization':
        case 'DevicesLocation':
            return { type: 'Devices' };
        case 'Settings':
            return { type: 'Settings' };
        case 'MyProfile':
            return { type: 'MyProfile' };
        case 'ManageAlarms':
            return { type: 'ManageAlarms', orgId: orgId };
        case 'ManageDeviceProfiles':
            return { type: 'ManageDeviceProfiles', orgId: orgId };
        case 'ManageUser':
            return { type: 'ManageUser', orgId: orgId };
        case 'ManageLocation':
            return { type: 'ManageLocation', orgId: orgId };
        case 'Legal':
            return { type: 'Legal' };
        default:
            return { type: 'InvalidRoute' };
    }
};

export const addLocationId = (appRoute: AppRoute, locationId: string): AppRoute => {
    switch (appRoute.type) {
        case 'Overview':
        case 'OverviewOrganization':
            return { type: 'OverviewLocation', locationId };
        case 'Timeline':
        case 'TimelineOrganization':
            return { type: 'TimelineLocation', locationId };
        case 'Devices':
        case 'DevicesOrganization':
            return { type: 'DevicesLocation', locationId };
        default:
            return appRoute;
    }
};

const routeByUrl = _.invert(AppRoutes);

export const determineCurrentAppRoute = (pathName: string): AppRoute => {
    for (const url of Object.keys(routeByUrl)) {
        const match = ReactRouter.matchPath(pathName, url);
        if (match && match.isExact) {
            const routeName = routeByUrl[url];

            const currentAppRoute = {
                type: routeName,
                ...match.params,
            };

            // TypeScript is upset if I try to use a string as the type above.
            // 'as'-ing it here instead of declaring currentAppRoute to be
            // an AppRoute up-front seems to work. :-)
            return currentAppRoute as AppRoute;
        }
    }

    return {
        type: 'InvalidRoute',
    };
};

export const getAppRouteCacheName = (pathName: string): string => {
    const currentAppRoute = determineCurrentAppRoute(pathName);

    return currentAppRoute.type;
};
